import { WorkflowTaskForm } from './workflow-form-task.interface';

export interface WorkflowFormSection {
    name: string;
    id?: string;
    workflowTasks: WorkflowTaskForm[];
}
